import { apiFetch } from "./client";
import type { components } from "./schema";

export type CompanyListItem = components["schemas"]["CompanyListItem"];
export type CompanyDetail = components["schemas"]["CompanyDetail"];
export type CompanyList = components["schemas"]["CompanyList"];
export type CompanyCounts = components["schemas"]["CompanyCounts"];
export type Advice = components["schemas"]["AdviceOut"];
export type AdviceAction = components["schemas"]["Action"];
export type NoReason = components["schemas"]["NoReason"];
export type HistoryEntry = components["schemas"]["HistoryEntry"];
export type Outcome = components["schemas"]["Outcome"];

export interface CompanyQuery {
  status?: components["schemas"]["Status"];
  forMe?: boolean;
  near?: boolean;
  sort?: components["schemas"]["Sort"];
  q?: string;
  cursor?: string | null;
  limit?: number;
}

export function listCompanies({ status, forMe, near, sort, q, cursor, limit }: CompanyQuery): Promise<CompanyList> {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (forMe) params.set("for_me", "true");
  if (near) params.set("near", "true");
  if (sort) params.set("sort", sort);
  if (q?.trim()) params.set("q", q.trim());
  if (cursor) params.set("cursor", cursor);
  if (limit) params.set("limit", String(limit));
  const query = params.toString();
  return apiFetch<CompanyList>(`/companies${query ? `?${query}` : ""}`);
}

export function getCompany(id: string): Promise<CompanyDetail> {
  return apiFetch<CompanyDetail>(`/companies/${encodeURIComponent(id)}`);
}

export function setFollow(id: string, follow: boolean): Promise<void> {
  return apiFetch<undefined>(`/companies/${encodeURIComponent(id)}/follow`, {
    method: follow ? "PUT" : "DELETE",
  });
}

export type CompanyCreate = components["schemas"]["CompanyCreate"];

export function addCompany(body: CompanyCreate): Promise<CompanyDetail> {
  return apiFetch<CompanyDetail>("/companies", { method: "POST", json: body });
}

export async function searchCompanies(q: string): Promise<CompanyListItem[]> {
  const body = await apiFetch<components["schemas"]["SearchResults"]>(`/search?${new URLSearchParams({ q }).toString()}`);
  return body.items;
}
